import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../shared/utils/error';
import ConfiguracionAppScreen from './screen';
import { useNotifications } from '../../../../shared/hooks/Notifications';
import { AppAdapter } from '../../../../infraestructure/persistence/rest/AppAdapter';

const ConfiguracionAppContainer = () => {

	const api = new AppAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	let [ data, setData ] = useState<any>([]);
	let [ fechasBloqueoParcial, setFechasBloqueoParcial ] = useState<any>(undefined);
	let result: any;

	useEffect(() => {
		getData();
		getFechasBloqueoParcial();
	}, []);

	const getData = async () => {
		try {
			result = await api.GetEstado();
			if(result.data!==undefined && result.data!=="")
			{
				setData(result.data.bloqueado)
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const getFechasBloqueoParcial = async () => {
		try {
			result = await api.GetFechasBloqueoParcial();
			if(result.data!==undefined && result.data!=="")
			{
				setFechasBloqueoParcial(result.data[0])
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const saveLockApp = async (isLockApp:any) => {
		try {
			result = await api.UpdateEstadoApp(isLockApp);
			if(result.data!==undefined && result.data!=="")
			{
				const estado = result.data.bloqueado;
                const msg:string = estado===true ?  `bloqueado` : (estado===false ? `desbloqueado` : `bloqueado parcialmente`)
                launchNotification({type:"success",title:"Bloqueo App",message:`Se ha ${msg} la aplicación.`})
				setData(estado)
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  	};

	  const saveFechasBloqueoParcial = async (dataFechasBloqueoParcial:any) => {
		try {
			result = await api.UpdateFechasBloqueoParcial(dataFechasBloqueoParcial);
			if(result.data!==undefined && result.data!=="")
			{
                launchNotification({type:"success",title:"Bloqueo App",message:`Se han modificado las fechas para el bloqueo parcial de la aplicación.`})
				setFechasBloqueoParcial(result.data[0])
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

	return (
		<>
		<ConfiguracionAppScreen
			data={data}
			fechasBloqueoParcial={fechasBloqueoParcial}
			saveLockApp={saveLockApp}
			saveFechasBloqueoParcial={saveFechasBloqueoParcial}
		/>
		</>
	);
};

export default ConfiguracionAppContainer;
